var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-10 -10 70 70",
    width: "1em",
    height: "1em",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.61 21.16q0-5.559-3.951-9.51-3.952-3.951-9.51-3.951t-9.51 3.95q-3.952 3.952-3.952 9.511 0 5.559 3.951 9.51 3.952 3.952 9.51 3.952t9.51-3.952 3.952-9.51zm15.385 25q0 1.562-1.142 2.704-1.142 1.142-2.704 1.142-1.623 0-2.704-1.142L33.139 38.588q-5.379 3.726-11.99 3.726-4.296 0-8.217-1.667Q9.01 38.979 6.17 36.14q-2.84-2.84-4.507-6.761-1.668-3.922-1.668-8.218t1.668-8.219 4.507-6.76q2.84-2.84 6.76-4.508Q16.854.007 21.15.007q4.297 0 8.218 1.667 3.921 1.668 6.76 4.508 2.84 2.84 4.508 6.76 1.668 3.922 1.668 8.219 0 6.61-3.727 11.989l10.307 10.306q1.111 1.111 1.111 2.704z"
  })));
}

export default SvgSearch;